import DashboardContainer from '../components/DashboardContainer/DashboardContainer.vue';
import StatPage from '../components/StatPage/StatPage.vue';
import AdminPage from '../components/AdminPage/AdminPage.vue';
import BookingPage from '../components/BookingPage/BookingPage.vue';
import AccountPage from '../components/AccountPage/AccountPage.vue';
import ContractPage from '../components/ContractPage/ContractPage.vue';
import DashboardPage from '../components/DashboardPage/DashboardPage.vue';
import AllocationPage from '../components/AllocationPage/AllocationPage.vue';
import ContractListPage from '../components/ContractListPage/ContractListPage.vue';
import ManageAllocationPage from '../components/ManageAllocationPage/ManageAllocationPage.vue';
import ContractManagementPage from '../components/ContractManagementPage/ContractManagementPage.vue';
import ContractManagementEditPage from '../components/ContractManagementEditPage/ContractManagementEditPage.vue';

export default {
    path: '/dashboard',
    component: DashboardContainer,
    meta: {
        authenticated: true
    },
    children: [
        {
            path: '/dashboard',
            component: DashboardPage
        },
        {
            path: '/dashboard/stats',
            component: StatPage,
        },
        {
            path: '/dashboard/admin',
            component: AdminPage,
            meta: {
                restrictContractManager: true,
                admin: true
            }
        },
        {
            path: '/dashboard/contract-management',
            component: ContractManagementPage,
            name: 'contractManagementOverview',
            meta: {
                restrictSupplier: true
            }
        },
        {
            path: '/dashboard/contract-management/:contractId/:supplierId',
            component: ContractManagementEditPage,
            name: 'contractManagement',
            meta: {
                restrictSupplier: true
            }
        },
        {
            path: '/dashboard/contract/:supplierId',
            component: ContractListPage,
            name: 'contractList'
        },
        {
            path: '/dashboard/contract/:supplierId/:contractId',
            component: ContractPage,
            name: 'contract'
        },
        {
            path: '/dashboard/account',
            component: AccountPage,
        },
        {
            path: '/dashboard/booking',
            component: BookingPage
        },
        {
            path: '/dashboard/allocation',
            component: AllocationPage,
            name: 'allocation',
            meta: {
                restrictXMLSuppliers: true
            }
        },
        {
            path: '/dashboard/allocation-management/:siteId',
            component: ManageAllocationPage,
            name: 'manageSiteAllocation',
            meta: {
                restrictXMLSuppliers: true
            }
        },
        {
            path: '/dashboard/allocation-management/:siteId/:accommodationSiteId',
            component: ManageAllocationPage,
            name: 'manageAccommodationAllocation',
            meta: {
                restrictXMLSuppliers: true
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./src/routes/routes-dashboard.js